module.exports = __webpack_public_path__ + "img/logogunsa.6dcc2245.png";